import { render, staticRenderFns } from "./tags-grid.vue?vue&type=template&id=2df1fc0e&scoped=true&"
import script from "./tags-grid.vue?vue&type=script&lang=ts&"
export * from "./tags-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df1fc0e",
  null
  
)

export default component.exports